// Import components, modules, pipes, directives...
// Included angular modules
// Included primeNg modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Directive1Directive } from './directives/directive1.directive';
import { Pipe1Pipe } from './pipes/pipe1.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ChipsModule } from 'primeng/chips';
import { SafePipe } from './pipes/sanitize.pipe';

import { FormsStepsModule } from './components/forms-steps/forms-steps.module';
import { PresentersModule } from './components/presenters/presenters.module';
import { UtilsService } from './services/utils/utils.service';
import { ProductosInformacionService } from '../core/providers/services/productos-informacion/productos-informacion.service';

// import maxLenghtValidator from './validators/max-length.validator';

// Components
// These components are common to the whole app
const COMPONENTS: any = [];

// Directives
// These directives are common to the whole app
const DIRECTIVES: (typeof Directive1Directive)[] = [ Directive1Directive ];

// Pipes
// These pipes are common to the whole app
const PIPES: (typeof Pipe1Pipe | typeof SafePipe)[] = [
  Pipe1Pipe,
  SafePipe
];

// Validators
const VALIDATORS: any[] = [
  // maxLenghtValidator
];

// PrimeNg Modules
const PRIME_NG_MODULES: (typeof ButtonModule)[] = [
  ButtonModule
];

// Modules used
// These modules are common to the whole app
const MODULES: (typeof ButtonModule | typeof RouterModule)[] = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  RouterModule,

  FormsStepsModule,
  PresentersModule,
  ChipsModule,
  ...PRIME_NG_MODULES
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
    ...VALIDATORS
  ],
  imports: [ ...MODULES ],
  exports: [
    ...MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES,
    ...VALIDATORS
  ],
  providers: [ UtilsService ]
})
export class SharedModule {
}
